import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import { get, post } from "helpers/api_helper"
import Notifications from "components/Notifications"
import { SHIFT_SCHEDULE_URL, SHIFT_DETAILS_URL } from "helpers/url_helper"
import "flatpickr/dist/themes/material_green.css"

const Shifts = () => {
    const [modal, setModal] = useState(false)
    const [editId, setEditId] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [shiftData, setShiftData] = useState({ rows: [], total_rows: 0 })
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ""
    })

    const [form, setForm] = useState({
        branch_id: "",
        shift_name: "",
        type: "",
        category: "Full timer",
        opening_time: "09:00:00",
        closing_time: "18:00:00",
        early_checkin: "0",
        late_checkin: "0",
        early_checkout: "0",
        late_checkout: "0",
        early_checkin_min: "",
        late_checkin_min: "",
        early_checkout_min: "",
        late_checkout_min: ""
    })

    const toggleModal = () => {
        setModal(!modal)
        if (!modal) {
            setEditId(null)
            setForm({
                branch_id: "",
                shift_name: "",
                type: "",
                category: "Full timer",
                opening_time: "09:00:00",
                closing_time: "18:00:00",
                early_checkin: "0",
                late_checkin: "0",
                early_checkout: "0",
                late_checkout: "0",
                early_checkin_min: "",
                late_checkin_min: "",
                early_checkout_min: "",
                late_checkout_min: ""
            })
        }
    }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(`${SHIFT_SCHEDULE_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.search}`);
        if (res.status === 200) {
            setShiftData({
                rows: res.response.rows || [],
                total_rows: res.response.total_rows || 0
            });
        }
        setIsLoading(false)
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);
        return () => clearTimeout(handler);
    }, [pagination]);

    const handleEdit = async (id) => {
        setEditId(id)
        const res = await get(`${SHIFT_DETAILS_URL}/${id}`)
        if (res.status === 200) {
            const data = res.response
            setForm({
                ...data,
                early_checkin: data.early_checkin?.toString(),
                late_checkin: data.late_checkin?.toString(),
                early_checkout: data.early_checkout?.toString(),
                late_checkout: data.late_checkout?.toString(),
            })
            setModal(true)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const url = editId ? `${SHIFT_SCHEDULE_URL}/${editId}` : SHIFT_SCHEDULE_URL
        const res = await post(url, form)
        if (res.status === 200) {
            Notifications(editId ? "Shift updated successfully!" : "Shift created successfully!")
            toggleModal()
            getData()
        }
    }

    const columns = [
        {
            dataField: "id",
            text: "#",
            formatter: (cell, row, rowIndex) => (pagination.page - 1) * pagination.limit + rowIndex + 1
        },
        { dataField: "opening_time", text: "OPENING TIME" },
        { dataField: "closing_time", text: "CLOSING TIME" },
        { dataField: "shift_name", text: "SHIFT" },
        { dataField: "category", text: "CATEGORY" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell === 1 || cell === "1"} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row.id)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" className="me-1"><i className="far fa-eye text-info"></i></Button>
                    <Button color="light" size="sm"><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }
    const greenBtnStyle = { backgroundColor: "#159858", borderColor: "#159858", color: "#fff" }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Dashboard | Office Time</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="HRMS" breadcrumbItem="Office Time" />

                    <Card>
                        <CardBody>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="text-uppercase" style={{ fontWeight: "bold", fontSize: "14px" }}>Office Time Filter</div>
                                <Button style={brownBtnStyle} onClick={toggleModal}>
                                    <i className="fas fa-plus me-1"></i> Add Office Time
                                </Button>
                            </div>
                            <Row className="mb-4">
                                <Col md={3}>
                                    <Select placeholder="Select Branch" options={[]} />
                                </Col>
                                <Col md={3}>
                                    <Select placeholder="Select Shift" options={[]} />
                                </Col>
                                <Col md={3}>
                                    <Select placeholder="Select Category" options={[]} />
                                </Col>
                                <Col md={3} className="d-flex align-items-end">
                                    <Button style={greenBtnStyle} className="me-2">Filter</Button>
                                    <Button style={brownBtnStyle}>Reset</Button>
                                </Col>
                            </Row>

                            <div className="text-uppercase mb-4" style={{ fontWeight: "bold", fontSize: "14px" }}>Office Time Lists</div>
                            <Datatables
                                columns={columns}
                                rows={shiftData.rows}
                                keyField="id"
                                rowsLength={shiftData.total_rows}
                                isTableHead={false}
                                isAdd={false}
                                isSearch={false}
                                loading={isLoading}
                                ssr={setPagination}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </div>

            <Modal isOpen={modal} toggle={toggleModal} size="xl">
                <ModalHeader toggle={toggleModal}>{editId ? "Edit Office Schedule" : "Office Schedule"}</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Branch <span className="text-danger">*</span></Label>
                                    <Select
                                        placeholder="Select Branch"
                                        options={[]}
                                        onChange={(e) => setForm(prev => ({ ...prev, branch_id: e.value }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Shift <span className="text-danger">*</span></Label>
                                    <Input
                                        type="text"
                                        placeholder="Enter Shift Name"
                                        value={form.shift_name}
                                        onChange={(e) => setForm(prev => ({ ...prev, shift_name: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Type</Label>
                                    <Select
                                        placeholder="Select Shift"
                                        options={[{ label: "General", value: "General" }, { label: "Night", value: "Night" }]}
                                        onChange={(e) => setForm(prev => ({ ...prev, type: e.value }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Category</Label>
                                    <Select
                                        placeholder="Select Category"
                                        options={[{ label: "Full timer", value: "Full timer" }, { label: "Part timer", value: "Part timer" }]}
                                        onChange={(e) => setForm(prev => ({ ...prev, category: e.value }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Opening Time <span className="text-danger">*</span></Label>
                                    <Flatpickr
                                        className="form-control"
                                        options={{ noCalendar: true, enableTime: true, dateFormat: "H:i:S" }}
                                        value={form.opening_time}
                                        onChange={(date, dateStr) => setForm(prev => ({ ...prev, opening_time: dateStr }))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup>
                                    <Label>Closing Time <span className="text-danger">*</span></Label>
                                    <Flatpickr
                                        className="form-control"
                                        options={{ noCalendar: true, enableTime: true, dateFormat: "H:i:S" }}
                                        value={form.closing_time}
                                        onChange={(date, dateStr) => setForm(prev => ({ ...prev, closing_time: dateStr }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="mt-4 mb-3" style={{ fontWeight: "bold" }}>CheckIn/Out Rule</div>

                        <Row>
                            <Col md={6}>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check form-switch me-2" dir="ltr">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={form.early_checkin === "1"}
                                            onChange={(e) => setForm(prev => ({ ...prev, early_checkin: e.target.checked ? "1" : "0" }))}
                                        />
                                    </div>
                                    <Label className="mb-0">Early Check In</Label>
                                </div>
                                <FormGroup>
                                    <Label>Can check in before (in minute)</Label>
                                    <Input
                                        type="number"
                                        placeholder="Enter Can check in before (in minute)"
                                        value={form.early_checkin_min}
                                        onChange={(e) => setForm(prev => ({ ...prev, early_checkin_min: e.target.value }))}
                                    />
                                </FormGroup>

                                <div className="d-flex align-items-center mb-3 mt-4">
                                    <div className="form-check form-switch me-2" dir="ltr">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={form.early_checkout === "1"}
                                            onChange={(e) => setForm(prev => ({ ...prev, early_checkout: e.target.checked ? "1" : "0" }))}
                                        />
                                    </div>
                                    <Label className="mb-0">Early Check out</Label>
                                </div>
                                <FormGroup>
                                    <Label>Can check out before (in minute)</Label>
                                    <Input
                                        type="number"
                                        placeholder="Enter Can check out before (in minute)"
                                        value={form.early_checkout_min}
                                        onChange={(e) => setForm(prev => ({ ...prev, early_checkout_min: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check form-switch me-2" dir="ltr">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={form.late_checkin === "1"}
                                            onChange={(e) => setForm(prev => ({ ...prev, late_checkin: e.target.checked ? "1" : "0" }))}
                                        />
                                    </div>
                                    <Label className="mb-0">Late Check In</Label>
                                </div>
                                <FormGroup>
                                    <Label>Can check in after (in minute)</Label>
                                    <Input
                                        type="number"
                                        placeholder="Enter Can check in after (in minute)"
                                        value={form.late_checkin_min}
                                        onChange={(e) => setForm(prev => ({ ...prev, late_checkin_min: e.target.value }))}
                                    />
                                </FormGroup>

                                <div className="d-flex align-items-center mb-3 mt-4">
                                    <div className="form-check form-switch me-2" dir="ltr">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={form.late_checkout === "1"}
                                            onChange={(e) => setForm(prev => ({ ...prev, late_checkout: e.target.checked ? "1" : "0" }))}
                                        />
                                    </div>
                                    <Label className="mb-0">Late Check out</Label>
                                </div>
                                <FormGroup>
                                    <Label>Can check out after (in minute)</Label>
                                    <Input
                                        type="number"
                                        placeholder="Enter Can check out after (in minute)"
                                        value={form.late_checkout_min}
                                        onChange={(e) => setForm(prev => ({ ...prev, late_checkout_min: e.target.value }))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="mt-4">
                            <Button style={brownBtnStyle} type="submit">
                                <i className="fas fa-plus me-1"></i> {editId ? "Update Office Time" : "Create Office Time"}
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default Shifts
